export const PERMS = {
    READ: 'invoicing_orders.read',
    UPDATE: 'invoicing_orders.update',
    DELETE: 'invoicing_orders.delete',
    CREATE: 'invoicing_orders.create',
    EXPORT: 'invoicing_orders.export',
}
